import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useSupplyMutations } from '../../../hooks/useNomenclatures';

const SupplyList = ({ items, onUpdate }) => {
  const mutations = useSupplyMutations();

  const fields = [
    { name: 'category', label: 'Category', type: 'text', placeholder: 'e.g., PPE, Medication' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="supplies"
      title="Supplies"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default SupplyList;

